<template>
  <div class="sidebar-logo-container">
    <h3>
      <img src="../../../assets/headLogo.png" />
      <span> 辽宁省沈抚改革创新<br />示范区智慧招商平台 </span>
    </h3>
  </div>
</template>

<script>
export default {
  name: "SidebarLogo",
  props: {},
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  background: #ffffff;
  text-align: center;
  overflow: hidden;
  display: flex;
  align-items: center;
  & h3 {
    font-weight: normal;
    // color: #fff;
    margin: 0;
    padding: 0;
    // line-height: 70px;
    text-align: center;
    font-size: 16px;
    display: flex;
    align-items: center;
    & img {
      width: 40px;
      margin-right: 15px;
    }
    span {
      text-align: left;
      padding-left: 15px;
      border-left: 1px solid rgba(51, 51, 51, 0.2);
      line-height: 1.5;
    }
  }
  & .sidebar-logo-link {
    display: flex;
    align-items: center;
    & .sidebar-logo {
      width: 48px;
      vertical-align: middle;
      margin-right: 12px;
    }
    & .sidebar-title {
      color: rgba(41, 59, 104, 1);
      font-weight: 600;
      font-size: 24px;
      margin: 0;
    }
    & p {
      font-size: 20px;
      color: rgba(41, 59, 104, 1);
      margin: 0;
    }
    & span {
      font-size: 26px;
      padding: 0 8px;
      color: rgba(111, 120, 139, 1);
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
